import React from 'react';
import { AI_DISCLAIMER } from '../../config/appText';
import './AiDisclaimer.css';

/**
 * App-wide AI disclaimer. Rendered once by Layout, so every page — including
 * any agent added later — gets it without repeating the copy.
 */
const AiDisclaimer: React.FC = () => (
  <p className="app-disclaimer">{AI_DISCLAIMER}</p>
);

export default AiDisclaimer;
